import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProductDetail from '@/components/ProductDetail.vue';
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductView',
  setup(__props) {

onMounted(() => {
  document.title = "Unifix Care - Product";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProductDetail))
}
}

})